/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Processed_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Duration to Process" |
*
* @param {Ad_Processed_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_processed_duration_label = /** @type {((inputs?: Ad_Processed_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Processed_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée à traiter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu verarbeitende Dauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata da elaborare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Длительность обработки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración a procesar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("处理时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理する長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोसेस की जाने वाली अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração a processar")
	return /** @type {LocalizedString} */ ("Duration to Process")
});